import styled from "styled-components";
import { xlg, md, sm, lg } from "../../../AppTheme.styled";

const StyledContentContainer = styled.div<{
  small?: boolean;
  margin?: number;
  vertical?: boolean;
  padding?: string;
  fullWidth?: boolean;
  textAlign?: string;
  centered?: boolean;
  spacing?: number;
}>`
  display: block;
  width: 100%;
  text-align: ${({ textAlign }) => textAlign || "center"};
  width: ${({ fullWidth }) => fullWidth && `100%!important`};
  max-width: 100%;
  margin: ${({ spacing }) => (spacing ? spacing * 8 : 0)}px
    ${(centered) => (centered ? "auto" : 0)};

  ${({ vertical }) =>
    vertical
      ? `
    height: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
  `
      : ""}

  ${sm} {
    width: ${({ small }) => (small ? 328 : 480)}px;
  }
  ${md} {
    width: ${({ small }) => (small ? 328 : 480)}px;
  }
  ${lg} {
    width: ${({ small }) => (small ? 328 : 680)}px;
  }
  ${xlg} {
  }
`;

export default StyledContentContainer;
